import * as React from 'react';
import { Box } from '~shared/components/Box';
import { UseIconProps, useIcon } from '../../useIcon';
import { IconTrueFalseSvg } from './IconTrueFalseSvg';

export type IconTrueFalseProps = UseIconProps;

export function IconTrueFalse(props: IconTrueFalseProps) {
  const iconProps = useIcon({ size: 'micro', ...props });
  return <Box tagName={IconTrueFalseSvg} {...iconProps} />;
}
